import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const CMSFOFFL_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cmsfoffl/logo.png",
        alt: "Comprehensive MedPsych Systems of Florida Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 28,
  state: "FL",
  departmentIds: [
    101, 102, 103, 106, 111, 113, 117, 120, 122, 123, 125, 130, 133, 140, 141, 153, 154, 165, 173,
    174, 254, 255, 256, 257, 264, 265, 266, 269,
  ],
};
